import { THEME_ENUM } from "constants/theme.constant";

const notAllowedRoutes = [
  "https://fairwayfore.com/ActivateAccount",
  "https://fairwayfore.com/reset-password",
  "https://fairwayfore.com/login",
  "https://fairwayfore.com/",
  "https://localhost:3000/",
  "https://localhost:3000/ActivateAccount",
  "https://localhost:3000/reset-password",
  "https://localhost:3000/login",
  "https://localhost:3000/ActionSuccessfully",
  "https://fairwayfore.com//ActionSuccessfully",
];

function buildThemeConfig() {
  const userDetailsJSON = localStorage.getItem("userDetails");
  const userDetails = userDetailsJSON
    ? JSON.parse(userDetailsJSON)
    : null;

  const userRole =
    userDetails?.status === "Error"
      ? ""
      : userDetails?.userRoles?.[0] || "";

  const isBlank = notAllowedRoutes.includes(window.location.href);

  if (userRole === "Admin" || userRole === "Company Admin") {
    return {
      themeColor: "emerald",
      direction: THEME_ENUM.DIR_LTR,
      mode: THEME_ENUM.MODE_LIGHT,
      locale: "en",
      primaryColorLevel: 600,
      cardBordered: true,
      panelExpand: false,
      controlSize: "md",
      navMode: THEME_ENUM.NAV_MODE_LIGHT,
      layout: {
        type: isBlank
          ? THEME_ENUM.LAYOUT_TYPE_BLANK
          : THEME_ENUM.LAYOUT_TYPE_STACKED_SIDE,
        sideNavCollapse: false,
      },
    };
  }

  return {
    themeColor: "emerald",
    direction: THEME_ENUM.DIR_LTR,
    mode: THEME_ENUM.MODE_LIGHT,
    locale: "en",
    primaryColorLevel: 600,
    cardBordered: true,
    panelExpand: false,
    controlSize: "md",
    navMode: THEME_ENUM.NAV_MODE_LIGHT,
    layout: {
      type: THEME_ENUM.LAYOUT_TYPE_MODERN,
      sideNavCollapse: false,
    },
  };
}

/**
 * ✅ THIS IS THE KEY PART
 * themeConfig is now a "live" value
 */
const themeConfig = new Proxy(
  {},
  {
    get(_, prop) {
      const config = buildThemeConfig();
      return config[prop]; // ✅ RETURN PROPERTY
    },
  }
);


console.log(themeConfig)
export { themeConfig };